import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import Preguntas from "../data/Preguntas";
import "./assets/estilos.css";


const Welcome = () => {
    const primeraPregunta = 1;
    const dataWelcome = 99;
    let img = "";
    let itemKey = 0;

    Preguntas.map((item) => {
        if (item.id == dataWelcome) {
            img = item.imagen;
            itemKey = item.id;
        }
        return item
    });


    return (
        <>
            <Container>
                <Row>

                    <Col>
                        <div className="contenedorElemento">
                            <Card>
                                <Card.Img variant="top" src={img} key={itemKey}/>
                                <Card.Body>
                                <div className="d-grid gap-2">
                                    <Link to={`/preguntas/${primeraPregunta}`}>
                                        <Button variant="success" size="lg" className="botonStart">Comenzar</Button>
                                    </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>

                </Row>
            </Container>
        </>
    );
}

export default Welcome;